import { useState } from "react";
// import cn from "classnames";
import TextField from '../../../audi-ui-components/TextField';
import Button from '../../../audi-ui-components/Button';
import Modal from '../../../audi-ui-components/Modal';
import { getStateFromPostcode } from '../../../functions/location';

const PostcodeModal = ({ isActive, onSubmit = ()=>{}, theme }) => {
  
  const [locPostcode, setLocPoscode] = useState("");
  const [error, setError] = useState(false);
  
  const handleEnterPostcode = () => {
    let s = getStateFromPostcode(locPostcode);
    if (s && s !== null) {
      onSubmit(s, locPostcode);
    } else {
      setError(true);
    }
  }
  
  return (
    <Modal isActive={isActive} variant="layer" className="postcodemodal">
      <p className="aui-headline-4 mb-3">Enter your postcode</p>
      <p className="mb-3">Statutory charges differ depending on your location. In order to provide the correct driveaway price, please enter your postcode.</p>
      <div className="mb-3">
        <TextField value={locPostcode} label="Postcode*" onChange={(v)=>{ setLocPoscode(v); setError(false); }} onEnter={handleEnterPostcode} isInvalid={error} invalidMessage="Please enter a valid postcode" theme={theme === "dark" ? "light" : null} />
      </div>
      <Button variant="primary" type="button" isStretched onClick={handleEnterPostcode} theme={theme === "dark" ? "light" : null}>Continue</Button>
      <p className="aui-small mt-4">This calculator is provided to you by Audi Financial Services ABN 20 097 071 460. The information shown in this calculator is an estimate only. The interest rates or repayment amounts are indicative only and actual rates or amounts will vary depending on your circumstances. You will need to visit your local dealer to get a detailed quote.</p>
    </Modal>
  );
};

export default PostcodeModal;
